import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CustomCheckBoxComponent } from './custom_check-box.component';

@NgModule({
  imports: [CommonModule, FormsModule],
  exports: [CustomCheckBoxComponent],
  declarations: [CustomCheckBoxComponent],
  providers: []
})
export class CustomCheckboxModule {}
